<template>
  <div>

    <!-- <div v-if="isAndroid" style="position: fixed;top:0;left:0;width:100%;height:100%">
      <div style="width:40%;position:relative;left: 50%;top: 20%;-webkit-transform: translate(-50%, -50%);-ms-transform: translate(-50%, -50%);transform: translate(-50%, -50%);">
        <wx-open-launch-weapp id="launch-btn" username="gh_76afa946b10f" :path="data.path" style="display:block;width:100%">
          <script type="text/wxtag-template">
            <style>.btn { width:100%;padding: 12px;color: white;background: #62b900;border:none;border-radius:4px;text-align:center;font-size:16px;
              }</style>
            <button class="btn">打开小程序</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div> -->

  </div>
</template>

<script>
export default {
  name: "chenzhen",
  data() {
    return {
      isAndroid: false,
      data: {},
    };
  },
  computed: {},
  created() {
    // this.getIsAndroid();
  },
  methods: {
    // getIsAndroid() {
    //   var u = navigator.userAgent;
    //   var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    //   this.isAndroid = isAndroid;
    //   let data = JSON.parse(decodeURIComponent(this.$route.query.data));
    //   console.log(data)
    //   this.data = data;
    //   if (!isAndroid) {
    //     location.href = data.url_scheme;
    //   }
    // },
  },
};
</script>
